import L from 'leaflet';

/**
 * Točak zumira samo uz Ctrl; bez njega se lista stranica.
 *
 * Mapa usred duge strane inače guta pomeranje: korisnik krene da skroluje, kursor
 * pređe preko mape i strana stane, a mapa odskoči na drugi zum. Zato se točak sam
 * pušta stranici, a zumira se uz Ctrl.
 *
 * Stoji na jednom mestu jer je pravilo isto na svakoj mapi. Dok nije bilo ovako,
 * radilo je samo na mapi predloga ture — operater je s pravom prijavio da „na
 * nekim mapama radi, na nekim ne".
 *
 * Vraća funkciju za odjavu, da je pozivalac zove pri raspremanju.
 */
export function ctrlWheelZoom(map: L.Map, element: HTMLElement): () => void {
  const onWheel = (event: WheelEvent) => {
    if (!event.ctrlKey) {
      return;
    }

    event.preventDefault();
    map.setZoom(map.getZoom() - Math.sign(event.deltaY));
  };

  // passive: false jer se poziva preventDefault — bez toga ga pregledač ignoriše.
  element.addEventListener('wheel', onWheel, { passive: false });

  return () => element.removeEventListener('wheel', onWheel);
}
